// services/userTask/UserTaskService.ts

import { UserTask, ReorderMove } from "../../interfaces/DTO/userTask/UserTask";

import apiClient from "../../core/apiClient";
import { BaseService } from "../BaseService";

const API_URL = "/user-tasks";

class UserTaskService extends BaseService<UserTask> {
  constructor() {
    super(API_URL);
  }

  async move(updates: ReorderMove[]): Promise<void> {
    await apiClient.patch(`${API_URL}/move`, updates);
  }

  async fetchByBoardId(boardId: number): Promise<UserTask[]> {
    const response = await apiClient.get<UserTask[]>(`${API_URL}/by-board`, {
      params: { board_id: boardId },
    });
    return response.data;
  }

  async fetchByUserId(userId: number, skip: number = 0, limit: number = 100): Promise<UserTask[]> {
    const response = await apiClient.get<UserTask[]>(`${API_URL}/by-user`, {
      params: {
        user_id: userId,
        skip,
        limit,
      },
    });
    return response.data;
  }

  async fetchByUserIdAndPolicyNumber(userId: number, policyNumber: number): Promise<UserTask[]> {
    const response = await apiClient.get<UserTask[]>(`${API_URL}/by-user-and-policy`, {
      params: { user_id: userId, policy_number: policyNumber },
    });
    return response.data;
  }
}

export const userTaskService = new UserTaskService();
